"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeIn = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const bounce = (num) => (0, app_1.keyframes) `
  from {
    transform: translateY(${num}px);
opacity: 0;
  }

  to {
 	 transform: translateY(0px);
opacity: 1;
	}
}
`;
const Wrap = app_1.styled.div `
  width: 100%;
  max-width: 100%;
  opacity: 0;
  transform: translateY(${(_, { $y }) => $y}px);
  animation-play-state: ${(_, { $inView }) => ($inView ? 'running' : 'paused')};
  animation-name: ${(_, { $y }) => bounce($y)};
  animation-duration: 0.55s;
  animation-delay: ${(_, { $delay }) => $delay}s;
  animation-fill-mode: forwards;
`;
function FadeIn({ children, className, delay = 0.25, y = 50, }) {
    const [animate, setAnimate] = (0, react_1.useState)(false);
    const { ref, inView } = (0, app_1.useInView)({ rootMargin: '-0% 0% -20% 0%' });
    (0, react_1.useEffect)(() => {
        if (inView) {
            setAnimate(true);
        }
    }, [delay, inView]);
    return ((0, jsx_runtime_1.jsx)(Wrap, Object.assign({ ref: ref, className: className, "$inView": animate, "$y": y, "$delay": delay }, { children: children })));
}
exports.FadeIn = FadeIn;
